export default __webpack_public_path__ + "static/media/waterfall.b26757ab.ogg";